/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { values } from 'lodash';
import { BridgeDocumentTypeLabel } from '@blend-types/eclose';

export enum DocumentTitles {
  LENDER_CLOSING_DOCUMENTS = 'Lender Closing Documents',
  LENDER_ESIGN_CLOSING_DOCUMENTS = 'Lender eSign Closing Documents',
  LENDER_INK_SIGN_CLOSING_DOCUMENTS = 'Lender Ink Sign Closing Documents',
  LENDER_PRELIMINARY_CLOSING_DOCUMENTS = 'Lender Preliminary Closing Documents',
  LENDER_RON_CLOSING_DOCUMENTS = 'Lender RON Closing Documents',
  REJECTED_RON_CLOSING_DOCUMENTS = 'Rejected RON Closing Documents',
  RON_CLOSING_DOCUMENTS = 'RON Closing Documents',
  SIGNED_CLOSING_DOCUMENTS = 'Signed Closing Documents',
  UNSIGNED_ESIGN_DOCUMENTS = 'Missing borrower signature on eSign documents',
  UPLOADED_DAY_OF_DOCUMENTS = 'Uploaded Day of Documents',
  UPLOADED_SIGN_AHEAD_DOCUMENTS = 'Uploaded/Tagged Sign Ahead Documents',
  CLOSING_SETTLEMENT_ONLY = 'Settlement Agent-Only Closing Documents',
}

export type DocumentDesignation = 'DAY_OF' | 'SIGN_AHEAD' | 'SIGNED' | 'UNDETERMINED' | 'REJECTED_RON';
export type DocumentCardLabel = 'RON' | 'Ink Sign' | 'Lender RON';

export const EcloseDocumentTypeLabels: Record<BridgeDocumentTypeLabel, BridgeDocumentTypeLabel> = {
  ADDITIONAL_CLOSING_DOCUMENT: 'ADDITIONAL_CLOSING_DOCUMENT',
  CLOSING_PACKAGE: 'CLOSING_PACKAGE',
  ESIGN_CLOSING_PACKAGE: 'ESIGN_CLOSING_PACKAGE',
  INK_SIGN_CLOSING_PACKAGE: 'INK_SIGN_CLOSING_PACKAGE',
  PRELIMINARY_CLOSING_DOCUMENTS: 'PRELIMINARY_CLOSING_DOCUMENTS',
  REJECTED_RON_CLOSING_PACKAGE: 'REJECTED_RON_CLOSING_PACKAGE',
  RON_CLOSING_PACKAGE: 'RON_CLOSING_PACKAGE',
  SIGNED_CLOSING_PACKAGE: 'SIGNED_CLOSING_PACKAGE',
  TITLE_DOCUMENT: 'TITLE_DOCUMENT',
  TRAILING_DOCUMENTS: 'TRAILING_DOCUMENTS',
  UNDETERMINED_CLOSING_PACKAGE: 'UNDETERMINED_CLOSING_PACKAGE',
};
export const ECLOSE_DOCUMENT_TYPE_LABELS = values(EcloseDocumentTypeLabels);
